export const fetchJson = async <T>(input: string, init?: RequestInit) => {
  const rawResponse = await fetch(input, init);
  if (!rawResponse.ok) {
    throw new Error(rawResponse.statusText);
  }

  try {
    return (await rawResponse.json()) as T;
  } catch {
    return null;
  }
};
